// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useCreateParticipantOnboardingRequest: () => UseMutationResult<
  void,
  string,
  {
    operator: string;
    compliance: string;
    registrar: string;
    clientOnboarder: string;
    participant: string;
    expiration: string;
    upgrader: string;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['createParticipantOnboardingRequest', ledgerApi],
    mutationFn: async ({
      operator,
      compliance,
      registrar,
      clientOnboarder,
      participant,
      expiration,
      upgrader,
    }) => {
      return ledgerApi.createParticipantOnboardingRequest(
        operator,
        compliance,
        registrar,
        clientOnboarder,
        participant,
        expiration,
        upgrader,
      );
    },
    retry: false,
  });
};

export default useCreateParticipantOnboardingRequest;
